import { createContext, useContext } from 'react';

/**
 * Whether the shell is hosting a docked side panel, for an occupant that has to
 * know but renders far below the shell.
 *
 * Separate from `ResponsiveLayoutContext` because the two answer different
 * questions and are decided by different flags. That one says the pages are laid
 * out by the new shell, which is `studio-tree-insights`. This one says there is a
 * column to dock into, with a resize handle and a fold, which follows the chat
 * itself on `studio-ai-model-insights`.
 *
 * They were one value until 2026-09-10, and the cost of that was the case this
 * split exists for: a tenant given the chat without the UI revamp got the chat as
 * a fixed floating card, because the shell never built the column. The card has
 * no resize handle and no close control, both of which belong to the column, so
 * turning on the assistant alone produced a panel that could not be sized or shut.
 *
 * `false` by default, which is also what a component outside the provider sees:
 * no host, so the occupant draws itself the way it did before any of this.
 */
export const PanelHostContext = createContext<boolean>(false);

export function useShellPanelHost(): boolean {
  return useContext(PanelHostContext);
}
